import React, { useEffect, useState } from "react"
import { OrderItem } from "depoto-core";
import { Btn, FormInput, FormSelect, FormTextarea, Modal, Toggle } from "./";
import { useCore } from "../hooks";
import { updateBill, OrderItemType } from "../utils";

type Props = {
  orderItem?: OrderItem
}
export const ModalCustomOrderItem: React.FC<Props> = ({ orderItem }) => {
  const { currentOrder, setCurrentOrder, vats } = useCore()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [oItem, setOItem] = useState<OrderItem>(orderItem || new OrderItem({
    type: OrderItemType.custom,
    quantity: 1,
    vat: vats?.find(v => v.default),
  }))
  const closeModal = () => setIsVisible(false)

  useEffect(() => {
    if (orderItem?.uuid) {
      setOItem(orderItem)
    }
  }, [orderItem?.quantity, orderItem?.sale, orderItem?.price, orderItem?.vat?.id])

  const updateOrderItem = (key: string, val: string | number | boolean) => {
    const nextOrderItem = { ...oItem }
    nextOrderItem[key] = val
    if (key === 'price' && nextOrderItem.vat?.coefficient) {
      nextOrderItem.priceWithoutVat = Number(val) * nextOrderItem.vat.coefficient
    }
    setOItem(nextOrderItem)
  }

  const setVat = (id: number) => {
    const vat = vats.find(v => v.id === id)
    console.log(id, vat)
    const nextOrderItem = { ...oItem }
    nextOrderItem.vat = vat
    setOItem(nextOrderItem)
  }

  const defaultVatId = () => vats?.find(v => v.default)?.id

  const addCustomOrderItem = () => {
    const fallbackVat = vats?.find(v => v.default) || vats?.[0]
    const nextOrderItem = { ...oItem, vat: oItem.vat || fallbackVat }
    if (typeof nextOrderItem.price === 'number' && nextOrderItem.vat?.coefficient) {
      nextOrderItem.priceWithoutVat = Number(nextOrderItem.price) * nextOrderItem.vat.coefficient
    }
    updateBill({ currentOrder, setCurrentOrder, orderItem: nextOrderItem })
    setIsVisible(false)
  }

  const removeOrderItem = () => {
    updateBill({ currentOrder, setCurrentOrder, orderItemUuidToRemove: oItem.uuid })
    setIsVisible(false)
  }

  return (
    <Modal
      modalOpenBtn={orderItem ? (
        <Btn className="btn-link" icon={'fa-pen'} onClick={() => setIsVisible(true)} />
      ) : (
        <Btn className="btn-link" children={'Volná položka'} onClick={() => setIsVisible(true)} />
      )}
      isVisible={isVisible}
      modalTitle={orderItem?.product?.id > 0 ? `Produkt: ${orderItem.product.fullName}` : 'Volná položka'}
      onClose={closeModal}
      content={
        <div className="flex flex-row">
          <div className="w-1/2">
            <FormInput label={'Název operace'} value={oItem.name} onChange={e => updateOrderItem('name', e)} />
            <FormInput label={'EAN'} value={oItem.ean} onChange={e => updateOrderItem('ean', e)} />
            <FormInput label={'Produktový kód'} value={oItem.code} onChange={e => updateOrderItem('code', e)} />
            <FormTextarea label={'Seriová čísla'} value={oItem.serial} onChange={e => updateOrderItem('serial', e)} />
          </div>
          <div className="w-1/2">
            <div className="flex flex-row gap-x-4">
              <div className="w-1/2">
                <FormInput type="number" label={'Počet'} value={`${oItem.quantity}`}
                  isDisabled={oItem.type === OrderItemType.voucherToCreate}
                  onChange={e => updateOrderItem('quantity', Number(e))} />
              </div>
              <div className="w-1/2">
                <FormInput type="number" label={'Cena'} value={`${oItem.price}`} onChange={e => updateOrderItem('price', Number(e))} />
              </div>
            </div>
            <div className="my-4">
              <Toggle label={
                <>
                  Položka pro následné uplatnění{' '}
                  <div className="font-normal">Platí pro dárkové poukazy</div>
                </>
              } value={oItem.isForSubsequentSettlement}
                onChange={e => updateOrderItem('isForSubsequentSettlement', e)} />
            </div>
            <div className="flex flex-row gap-x-4">
              <div className="w-1/2">
                <FormSelect label={'Daň'} value={`${oItem.vat?.id || defaultVatId()}`} options={vats.map(v => ({ label: v.name, value: v.id }))} onChange={e => setVat(Number(e))} />
              </div>
              <div className="w-1/2">
                <FormInput type="number" label={'Sleva'} value={`${oItem.sale}`} onChange={e => updateOrderItem('sale', Number(e))} />
              </div>
            </div>
            <FormTextarea label={'Poznámka'} textAreaclassName="w-full" value={oItem.note} onChange={e => updateOrderItem('note', e)} />
          </div>
        </div>
      }
      footerContent={
        <div className="flex flex-row justify-between items-center">
          <div>
            <Btn className="btn-base-100 mr-2" icon={'far fa-ban'} children={'Zrušit'} onClick={() => setIsVisible(false)} />
            {orderItem ? (
              <Btn className="btn-error" children={'Smazat'} icon={'far fa-trash-can'} onClick={removeOrderItem} />
            ) : null}
          </div>
          <Btn className="btn-primary" icon={'fa-check'} children={orderItem ? 'Ok' : 'Přidat položku'} onClick={addCustomOrderItem} />
        </div>
      }
    />
  )
}
